<a class="d-inline-flex boton-eliminar mx-2 gap-1"
  [ngClass]="[customClass, disabled ? 'disabled' : '', iconPosition=='end' ? 'flex-row-reverse' : '']"
  (click)="!disabled && onClick()">
  <i *ngIf="icon=='delete'" class="fa-regular fa-trash-can"></i>
  <i *ngIf="icon=='plus'" class="fa-solid fa-plus"></i>
  <i *ngIf="icon=='close'" class="fa-solid fa-xmark"></i>
  <i *ngIf="icon=='arrow-right'" class="fa-solid fa-arrow-right"></i>
  <i *ngIf="icon=='arrow-left'" class="fa-solid fa-arrow-left"></i>
  <ng-content></ng-content>
</a>
